import { RunStates } from './runStates'
export const StateChanges = {
  // ** front end *
  SET_OVERVIEW: 'SET_OVERVIEW',
  CLEAR_RESULTS: 'CLEAR_RESULTS',
  SET_SOUNDPLAY_CALL_TEXT: 'SET_SOUNDPLAY_CALL_TEXT',
  SET_SEMANTICS: 'SET_SEMANTICS',
  INSERT_SEMANTIC_WORD: 'INSERT_SEMANTIC_WORD',
  REMOVE_SEMANTIC_ITEM: 'REMOVE_SEMANTIC_ITEM',
  SET_TEXT_FOR_CHARUZIT_API_CALL: 'SET_TEXT_FOR_CHARUZIT_API_CALL',
  SET_LET_SWAP: 'SET_LET_SWAP',
  SET_VOC_SWAP: 'SET_VOC_SWAP',
  SET_NO_RESULTS: 'SET_NO_RESULTS',
  SET_RHYME_MODE: 'SET_RHYME_MODE',
  SET_MODEL: 'SET_MODEL',
  SET_MIN_SYL: 'SET_MIN_SYL',
  SET_MAX_SYL: 'SET_MAX_SYL',
  SET_MAX_CONS: 'SET_MAX_CONS',
  SET_SEARCH_SORT: 'SET_SEARCH_SORT',
  SET_POS: 'SET_POS',
  SET_NUMBER: 'SET_NUMBER',
  SET_GENDER: 'SET_GENDER',
  SET_PERSON: 'SET_PERSON',
  SET_TENSE: 'SET_TENSE',
  SET_STATUS: 'SET_STATUS',
  SET_SUFFIX: 'SET_SUFFIX',
  SET_GENDER_SUFFIX: 'SET_GENDER_SUFFIX',
  SET_PERSON_SUFFIX: 'SET_PERSON_SUFFIX',
  SET_NUMBER_SUFFIX: 'SET_NUMBER_SUFFIX',
  SET_CONSONANCE_MODE: 'SET_CONSONANCE_MODE',
  SET_ASSONANCE_MODE: 'SET_ASSONANCE_MODE',
  SET_ACCENT: 'SET_ACCENT',
  SET_DISPLAY_NAMES: 'SET_DISPLAY_NAMES',

  // ** concerning APIs *
  SOUNDPLAY_RUNNING: 'SOUNDPLAY_RUNNING',
  SOUNDPLAY_TIMED_OUT: 'SOUNDPLAY_TIMED_OUT',
  SOUNDPLAY_FAILED: 'SOUNDPLAY_FAILED',
  SET_SOUNDPLAY_RESULTS: 'SET_SOUNDPLAY_RESULTS',

  CHARUZIT_RUNNING: 'CHARUZIT_RUNNING',
  CHARUZIT_FAILED: 'CHARUZIT_FAILED',
  CHARUZIT_COMPLETE: 'CHARUZIT_COMPLETE',
  CHARUZIT_TIMED_OUT: 'CHARUZIT_TIMED_OUT',
  SET_CHARUZIT_RESULTS: 'SET_CHARUZIT_RESULTS',

  SET_CHARUZIT_RESULTS_ASSONANCE: 'SET_CHARUZIT_RESULTS_ASSONANCE',
  SET_BIBLE_RESULTS_ASSONANCE: 'SET_BIBLE_RESULTS_ASSONANCE',
  SET_CHARUZIT_RESULTS_CONSONANCE: 'SET_CHARUZIT_RESULTS_CONSONANCE',
  SET_BIBLE_RESULTS_CONSONANCE: 'SET_BIBLE_RESULTS_CONSONANCE',

  SET_CHARUZIT_BIBLE_RESULTS: 'SET_CHARUZIT_BIBLE_RESULTS',
  SET_XX_RESULTS: 'SET_XX_RESULTS',
  SET_COMMON_RESULTS: 'SET_COMMON_RESULTS',
  SET_NS_RESULTS: 'SET_NS_RESULTS',
  SET_LONG_RESULTS: 'SET_LONG_RESULTS',
  SET_FEM_RESULTS: 'SET_FEM_RESULTS',
  SET_COMMON_TEMP_RESULTS: 'SET_COMMON_TEMP_RESULTS',
  SET_TEXT_FOR_CHARUZIT_TEMP_API_CALL: 'SET_TEXT_FOR_CHARUZIT_TEMP_API_CALL',
  SET_CHARUZIT_SINGLE_RESULTS: 'SET_CHARUZIT_SINGLE_RESULTS',

  SET_TAVNIT_PARAMS: 'SET_TAVNIT_PARAMS',

/*
  SET_TAVNIT_RESULTS: 'SET_TAVNIT_RESULTS',
  SET_TAVNIT_BIBLE_RESULTS: 'SET_TAVNIT_BIBLE_RESULTS',
  SET_TAVNIT_COMMON_RESULTS: 'SET_TAVNIT_COMMON_RESULTS',
  SET_TAVNIT_BASE_RESULTS: 'SET_TAVNIT_BASE_RESULTS',
  SET_TAVNIT_LONG_RESULTS: 'SET_TAVNIT_LONG_RESULTS',
  SET_TAVNIT_FEM_RESULTS: 'SET_TAVNIT_FEM_RESULTS', */

  SET_VIEW_MODE: 'SET_VIEW_MODE',

  SET_INCLUDE_FOREIGN: 'SET_INCLUDE_FOREIGN',
  SET_INCLUDE_NON_BASE: 'SET_INCLUDE_NON_BASE',
  SET_INCLUDE_BIBLE: 'SET_INCLUDE_BIBLE',

  //Word list
  ADD_WORD_TO_LIST: 'ADD_WORD_TO_LIST',
  REMOVE_WORD_FROM_LIST: 'REMOVE_WORD_FROM_LIST',
  REPLACE_LIST: 'REPLACE_LIST',
  CLEAR_LIST: 'CLEAR_LIST'
}

export const Actions = {
  RUN_CHARUZIT: 'RUN_CHARUZIT',
  RUN_SOUNDPLAY: 'RUN_SOUNDPLAY',
  RUN_CHARUZIT_CALL: 'RUN_CHARUZIT_CALL',
  RUN_TAVNIT: 'RUN_TAVNIT',
  RELOAD_FROM_URL: 'RELOAD_FROM_URL'
}

export const BlankState = {
  charuzitApiState: RunStates.NOT_RUN,
  soundplayState: RunStates.NOT_RUN,
  soundplayCallText: '',
  semanticKeywordsArr: [],
  textForCharuzitApiCall: '',
  searchModel: 'rhyme',

  morph: {
    posIndex: 0,
    numberIndex: 0,
    personIndex: 0,
    genderIndex: 0,
    statusIndex: 0,
    tenseIndex: 0,
    suffixIndex: 0,
    suffixNumberIndex: 0,
    suffixGenderIndex: 0,
    suffixPersonIndex: 0
  },


  soundplayResults: [],
  charuzitApiResponse: [],
  charuzitBibleResponse: [],
  charuzitAssonanceResponse: [],
  bibleAssonanceResponse: [],
  charuzitSemanticAssonanceResponse: [],
  charuzitConsonanceResponse: [],
  bibleConsonanceResponse: [],
  charuzitSemanticConsonanceResponse: [],


  preSubmissionOptions: {
    rhymeMode: 'half',
    maxSyllable: '7+',
    minSyllable: '1',
    maxConsonant: '2',
    minConsonant: '1',
    accent: self.searchModel === 'tavnit' ? 'returnall' : 'matchinput',
    displayNames: false,
    includeNonBase: true,
    includeForeign: true,
    includeTanakh: false,
    LetSwapSettings: {
      vocalSwap: true,
      consonentLetSwap: true
    },
    displayConsonance: true,
    displayAssonance: true,
  },

  commonResults: [],
  nsResults: [],
  longResults: [],
  femResults: [],

  AScommonResults: [],
  ASnsResults: [],
  ASlongResults: [],
  ASfemResults: [],

  CONcommonResults: [],
  CONnsResults: [],
  CONlongResults: [],
  CONfemResults: [],

  charuzitMoreResults: false,
  bibleMoreResults: false,
  commonMoreResults: false,
  longMoreResults: false,
  noSuffixMoreResults: false,
  femMoreResults: false,


  charuzitMoreResultsAS: false,
  bibleMoreResultsAS: false,
  commonMoreResultsAS: false,
  longMoreResultsAS: false,
  noSuffixMoreResultsAS: false,
  femMoreResultsAS: false,

  charuzitMoreResultsCON: false,
  bibleMoreResultsCON: false,
  commonMoreResultsCON: false,
  longMoreResultsCON: false,
  noSuffixMoreResultsCON: false,
  femMoreResultsCON: false,

  displayOverview: true,
  displayDefault: false,
  displayBible: false,
  displayCommon: false,
  displayNS: false,
  displayLong: false,
  displayFem: false,
  noResults: false,
  personalWords: localStorage.SAVED_WORDS ? localStorage.SAVED_WORDS.split(',') : [],
  queriedData: {},
  tavnitSearchParams: [],
  patternTokens: []
}